export default __webpack_public_path__ + "static/media/Sarah_9781846161940.08801d14.jpg";